import React, { useEffect, useRef, useState } from "react"
import { Input, Form, Tooltip, DatePicker, Space, message, Tag } from "antd"
import TableCustom from "src/components/Table/CustomTable"
import SvgIcon from "src/components/SvgIcon"
import Button from "src/components/MyButton/Button"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import CB1 from "src/components/Modal/CB1"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import dayjs from "dayjs"
import PackageService from "src/services/PackageService"

import STORAGE, { getStorage } from "src/lib/storage"
import FilterPackage from "../../PhonePackage/components/FilterPackage"
import { InputSearchStyle } from "../../HumanResource/Work/Task/styled"
import TabsBar from "../../PhonePackage/components/TabsBar"
import RejectModal from "../../PhonePackage/Modal/RejectModal"

const PhonePackage = () => {
  const [searchValue, setSearchValue] = useState("")
  const [dataSelected, setDataSelected] = useState([])
  const [dataSource, setDataSource] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [editingRecord, setEditingRecord] = useState(null)
  const [modalType, setModalType] = useState(null) // null | "create" | "edit"
  const [form] = Form.useForm()
  const [rejectReason, setRejectReason] = useState("")
  const [selectedId, setSelectedId] = useState(null)
  const [openRejectModal, setOpenRejectModal] = useState(false)
  const [data, setData] = useState([])
  const [tabChange, setTabChange] = useState("all")
  const [refresh, setRefresh] = useState(false)
  const [summary, setSummary] = useState({})
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")

  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || ""
    console.log(keyword)
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }
  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status: "0",
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: "1",
    },
    reject: {
      type: "reject",
      name: "Từ chối",
      status: "2",
    },
  }

  useEffect(() => {
    setFilter(prev => ({
      ...prev,
      status: Tabs[tabChange]?.status ?? "",
    }))
  }, [tabChange])

  const columns = [
    // { title: "STT", dataIndex: "index", render: (_, __, idx) => idx + 1 },
    { title: "Tên gói cước", dataIndex: "name", align: "center" },
    {
      title: "Quốc gia",
      dataIndex: ["country", "title"],
      render: name => name || "-",
       align: "center"
    },
    {
      title: "Nhà mạng",
      dataIndex: ["network", "name"],
      render: name => name || "-",
       align: "center"
    },
    {
      title: "Nhà cung cấp",
      dataIndex: ["supplier", "name"],
      render: name => name || "-",
       align: "center"
    },
    {
      title: "Local/Roaming",
      dataIndex: "service_type",
      render: key => {
        const found = serviceType.find(item => item.key === key)
        return found ? found.value : key
      },
       align: "center"
    },

    {
      title: "Dung lượng DATA",
      dataIndex: "data_quantity",
      render: text => `${text} GB`,
       align: "center"
    },
    {
      title: "Giá bán",
      dataIndex: "price",
      render: text => {
        return new Intl.NumberFormat().format(text)
      },
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      render: (_, record) => {
        let dailyTotalLabel = ""
        switch (record.daily_total) {
          case "daily":
            dailyTotalLabel = "Daily"
            break
          case "total":
            dailyTotalLabel = "Total"
            break
          default:
            dailyTotalLabel = "Unknown"
            break
        }

        const thenStopItem = serviceType.find(
          item => item.key === record.then_stop,
        )
        const thenStopLabel = thenStopItem
          ? thenStopItem.value
          : record.then_stop || "Unknown"

        const dateLabel = record.date ? `${record.date} ngày` : "Chưa có ngày"

        return (
          <span>{`${dailyTotalLabel} / ${thenStopLabel} / ${dateLabel}`}</span>
        )
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: status => {
        switch (String(status)) {
          case "0":
            return (
              <span style={{ color: "orange", fontWeight: "bold" }}>
                Chờ duyệt
              </span>
            )
          case "1":
            return (
              <span style={{ color: "green", fontWeight: "bold" }}>
                Đã duyệt
              </span>
            )
          case "2":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Từ chối</span>
            )
          default:
            return <span style={{ color: "gray", fontWeight: "bold" }}></span>
        }
      },
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const onlyView = record.status === "1" || record.status === "2"

        return (
          <PopupAction>
            {permissions.includes("package.generate.detail") ? (
              <div onClick={() => handleViewDetail(record)}>
                <IconBase name="eye" />
                <span>Xem chi tiết</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("package.generate.update") && !onlyView ? (
              <div onClick={() => handleEdit(record)}>
                <IconBase name="edit" />
                <span>Sửa</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("package.generate.delete") && !onlyView ? (
              <div onClick={() => handleSingleDelete(record)}>
                <IconBase name="delete" />
                <span>Xóa</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("package.generate.browse") && !onlyView ? (
              <div onClick={() => handleBrowse(record)}>
                <IconBase name="approval" />
                <span>Duyệt</span>
              </div>
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("package.generate.refuse") && !onlyView ? (
              <div onClick={() => handleReject(record)}>
                <IconBase name="cancelApproval" />
                <span>Từ chối</span>
              </div>
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]
  const typeSim = [
    { key: "sim_data", value: "SIM + DATA" },
    { key: "sim", value: "SIM" },
  ]
  const serviceType = [
    { key: "roaming", value: "Roaming" },
    { key: "local", value: "Local" },
  ]

const fetchListPackage = async (filter, keyword) => {
  setLoading (true)
  try {
    const response = await PackageService.listPackages({
      page: pagination.current,
      per_page: pagination.pageSize,
      filter: {
        type: 0,
        ...filter,
      },
      keyword,
    });

    if (response?.success) {
      const packages = response?.success?.data || [];
      const total = response?.success?.total || packages.length;

      setPagination(prev => ({
        ...prev,
        total,
      }));
      setSummary({ totalAccounts: total });
      setData(packages);
    } else {
      message.error(response?.error?.message || "Đã xảy ra lỗi");
      console.error("Error response:", response?.error || response);
    }
  } catch (err) {
    message.error("Lỗi không xác định");
    console.error("Exception in fetchListPackage:", err);
         }
       finally {
    setLoading(false)
  }
};

  useEffect(() => {
    fetchListPackage(filter, keyword)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchListPackage(filter, keyword)
      }
    }
  }, [refresh, filter, keyword])
  const handleBrowse = async record => {
    try {
      const response = await PackageService.packageBrowse(record.ID)
      if (response?.message?.includes("thành công")) {
        message.success("Duyệt gói cước thành công")
        fetchListPackage(filter, keyword)
      } else {
        message.error("Duyệt gói cước thất bại")
      }
    } catch (error) {
      console.error("Lỗi khi duyệt gói cước:", error)
      message.error("Đã xảy ra lỗi khi duyệt gói cước.")
    }
  }

  const handleReject = record => {
    setSelectedRecord(record.ID) // Lưu chỉ ID của record
    setOpenRejectModal(true) // Mở modal từ chối
  }

  const handleRefuse = async () => {
    try {
      const response = await PackageService.packageRefuse(selectedRecord, {
        note: rejectReason,
      })
      if (response?.message?.includes("thành công")) {
        message.success("Từ chối gói cước thành công")
        fetchListPackage(filter, keyword)
        setRejectReason("")
      } else {
        message.error("Từ chối gói cước thất bại")
      }
    } catch (error) {
      console.error("Lỗi khi hủy duyệt gói cước:", error)
      message.error("Đã xảy ra lỗi khi hủy duyệt gói cước.")
    } finally {
      setOpenRejectModal(false)
    }
  }
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }
  const handleEdit = record => {
    setEditingRecord(record)
    setModalType("edit")
    form.setFieldsValue(record)
  }
  const handleViewDetail = async record => {
    setSelectedId(record.ID)
    setModalType("view")
  }
  const handleSearch = value => {
    setSearchValue(value)
  }

  const handleOpenModal = () => {
    setModalType("create")
    form.resetFields()
  }

  const handleModalOk = values => {
    // console.log("Dữ liệu tạo mới:", values)
    setModalType(null)
    setRefresh(prev => !prev)
  }
  const handleDelete = async (ids = []) => {
    try {
      const res = await PackageService.packageDelete({ ids })
      if (res?.message?.toLowerCase().includes("thành công")) {
        message.success("Xóa gói cước thành công!")
        setDataSource(prev => prev.filter(item => !ids.includes(item.id)))
        // setDataSelected([])
        fetchListPackage(filter, keyword)
      } else {
        message.error("Xóa gói cước không thành công!")
      }
    } catch (error) {
      console.error("Lỗi khi xóa gói cước:", error)
      message.error("Đã xảy ra lỗi khi xóa gói cước!")
    }
  }

  const handleSingleDelete = record => {
    CB1({
      title: `Bạn có chắc chắn muốn xóa gói cước <strong>${record?.name}</strong>?`,
      iconName: "remove",
      okText: "Xóa",
      onOk: async close => {
        await handleDelete([record.ID])
        close()
      },
    })
  }

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("package.generate")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#005F90",
            margin: 0,
          }}
        >
          GIÁ BÁN GÓI CƯỚC
        </h3>
      </div>
      {/* <TabsBar tabChange={tabChange} setTabChange={setTabChange} /> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
        }}
      >
        {!!dataSelected.length && (
          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              marginRight: 8,
            }}
          >
            <ButtonCircle
              title="Duyệt đã chọn"
              iconName="check-circle"
              onClick={() =>
                CB1({
                  title: `Bạn có chắc chắn muốn duyệt <strong>${dataSelected.length}</strong> bản ghi không?`,
                  icon: "check-circle",
                  okText: "Đồng ý",
                  onOk: async close => {
                    // Logic phê duyệt
                    close()
                  },
                })
              }
            />
            <ButtonCircle
              title="Xóa đã chọn"
              iconName="remove"
              onClick={() =>
                CB1({
                  title: `Bạn có chắc chắn muốn xóa <strong>${dataSelected.length}</strong> bản ghi không?`,
                  iconName: "remove",
                  okText: "Đồng ý",
                  onOk: async close => {
                    await handleDelete(dataSelected.map(item => item.ID))
                    close()
                  },
                })
              }
            />
          </div>
        )}
        <FilterPackage setFilter={setFilter} />
        <div style={{ marginLeft: "auto" }}>
          <Space>
            <InputSearchStyle>
              <Input
                allowClear
                className="custom-input"
                maxLength={50}
                placeholder="Nhập thông tin..."
                onChange={e => (inputSearchRef.current = e.currentTarget.value)}
                onPressEnter={onSearch}
                onClear={onClearSearch}
              />
              <div className="custom-icon-search">
                <SvgIcon name="searchStatistic" onClick={onSearch} />
              </div>
            </InputSearchStyle>
          </Space>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>
      <TableCustom
        rowKey="ID"
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        isPrimary
        columns={columns}
        dataSource={data}
        loading = {loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: setSummary.totalAccounts,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        scroll={{ x: "max-content" }}
        bordered
      />
      {/* {modalType === "edit" && (
        <ModalEdit
          open={true}
          onCancel={() => setModalType(null)}
          record={editingRecord}
          fetchData={() => setRefresh(prev => !prev)}
        />
      )}
      {modalType === "view" && (
        <ViewDetailModal
          open={true}
          onCancel={() => setModalType(null)}
          form={form}
          recordId={selectedId}
        />
      )} */}
      <RejectModal
        open={openRejectModal}
        onCancel={() => setOpenRejectModal(false)}
        onConfirm={handleRefuse}
        setRejectReason={setRejectReason}
      />
    </div>
  )
}

export default PhonePackage
